import { render, staticRenderFns } from "./CartSidebarItem.vue?vue&type=template&id=32acd26a"
import script from "./CartSidebarItem.vue?vue&type=script&lang=js"
export * from "./CartSidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports